import { inject, Injectable, Injector } from '@angular/core';
import { MissingTranslationHandler, MissingTranslationHandlerParams } from '@ngx-translate/core';

import { TranslationLoaderHelper } from 'app/core/internationalization/translation-loader-helper';

@Injectable()
export class CustomMissingTranslationHandler implements MissingTranslationHandler {
  private readonly injector = inject(Injector);

  private _isLoading = false;
  private _initialized = false;

  /**
   * Lazily subscribes to TranslationLoaderHelper.loading$ on first use.
   * Cannot inject TranslationLoaderHelper directly in the constructor because
   * TranslationLoaderHelper → TranslateService → MissingTranslationHandler → TranslationLoaderHelper
   * would form a circular dependency.
   */
  private init(): void {
    if (this._initialized) {
      return;
    }
    this._initialized = true;
    this.injector.get(TranslationLoaderHelper).loading$
      .subscribe((isLoading) => {
        this._isLoading = isLoading;
      });
  }

  public handle(params: MissingTranslationHandlerParams): string {
    this.init();

    // Suppress missing key output while module translations are still being fetched.
    // Once loading finishes, ngx-translate will re-evaluate the key and find the real value.
    if (this._isLoading) {
      return '';
    }

    if (typeof sessionStorage !== 'undefined' && sessionStorage.getItem('DEBUG_MISSING_TRANSLATIONS') === 'true') {
      console.error(`[MISSING_TRANSLATION] Key: "${params.key}"`);
    }

    return (params.interpolateParams
      ? params.translateService.parser.interpolate(params.key, params.interpolateParams)
      : params.key) || '';
  }
}
